import { createAction } from 'redux-actions';
import { NOTIFICATIONS } from '../constants/actionTypes';

export const shiftNotification = createAction(NOTIFICATIONS.SHIFT);
export const enqueueNotification = createAction(NOTIFICATIONS.ENQUEUE, message => {
  return typeof message === 'string'
    ? {
        text: message,
      }
    : message;
});



// WEBPACK FOOTER //
// ./src/shared/actions/notifications.js